import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@bya/auth/services/authentication.service';
import { ByaHttp } from 'app/services/bya-http';
import { NgxFreshdeskWebwidgetService } from 'ngx-freshdesk-webwidget';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskService extends ByaHttp {

  constructor(
      private _NgxFreshdeskWebwidgetService: NgxFreshdeskWebwidgetService,
      private http: HttpClient,
      protected dialog: MatDialog, 
      protected authService:AuthService
  ) {
      super(dialog, authService);
  }

setUserShowTikect(nameUser:string, userName:string, emailUser:string, telefonoUser:string)
{
    let token:string = "";
    this._NgxFreshdeskWebwidgetService.FreshworksWidget('identify', 'ticketForm', {
        name: userName,
        email: emailUser,
        subject:'SIGNUS ARCHIVO:'
    });

    this.GetToken((_token_)=> {
        token = _token_;  
        this._NgxFreshdeskWebwidgetService.FreshworksWidget('authenticate', { token: token });
        this._NgxFreshdeskWebwidgetService.FreshworksWidget('show');

        this._NgxFreshdeskWebwidgetService.FreshworksWidget('identify', 'ticketForm', {
            subject:`SIGNUS ARCHIVO: ${nameUser} (${userName}) - ${emailUser} - ${telefonoUser}`,
            description:'Escriba su solicitud',
        });
    });
    this._NgxFreshdeskWebwidgetService.FreshworksWidget('hide', 'launcher');
}

openTikect(){
  // this._NgxFreshdeskWebwidgetService.FreshworksWidget('open', 'ticketForm');
  this._NgxFreshdeskWebwidgetService.FreshworksWidget('open');
  this._NgxFreshdeskWebwidgetService.FreshworksWidget('hide', 'launcher');
}


closeTicket(){
  this._NgxFreshdeskWebwidgetService.FreshworksWidget('identify', 'ticketForm', {
      name: '',
      email: '',
      subject:'SIGNUS ARCHIVO:'
  });
  //FreshworksWidget ('hide', 'launcher'); 
  this._NgxFreshdeskWebwidgetService.FreshworksWidget('hide', 'launcher');
}

private GetToken(callback){
  this.getToken()
      .subscribe(response => {
          if(!response) return;
          callback(response.token);
      }) 
}
getToken(): Observable<any> {
  return this.http.get<any>(this.baseUrl + 'api/JwtToken')
      .pipe(
          tap(_ => this.log('fetched task')),
          catchError(this.handleError<any>('OBTENER TOKEN', null))
      );
}

}
